<template>
    <div>
        <div class="form-inline">
            <b-col sm="3" class="mx-0 px-0 my-0 py-0">
                <b-input-group v-if="!useTimeInput">
                    <b-form-timepicker
                        :key="aangeraakt"
                        v-model="localSelected.registratieTijd"
                        @input="set_inputTimePicker"
                        :disabled="!editAllowed"
                        :class="giveBGclass"
                    />
                    <cheese-tijd
                        v-model="datumtijd"
                        @change="set_inputCheeseTijd"
                        :disabled="!editAllowed"
                    />
                </b-input-group>
                <b-input-group v-if="useTimeInput">
                    <b-form-input
                        v-model="localDate"
                        :type="'date'"
                        @blur="setPerstijd"
                        :disabled="!editAllowed"
                        :class="giveBGclass"
                    ></b-form-input>
                    <b-form-input
                        v-model="localTijd"
                        :type="'time'"
                        @blur="setPerstijd"
                        :disabled="!editAllowed"
                        :class="giveBGclass"
                    ></b-form-input>
                </b-input-group>
            </b-col>

            <b-col :sm="1" class="mx-0 px-0 my-0 py-0">
                <b-form-input
                    :placeholder="$t('com_timespan', { ns: 'common' })"
                    v-model="localSelected.tijdsduur"
                    readonly
                ></b-form-input>
            </b-col>

            <b-col sm="2" class="mx-0 px-0 my-0 py-0">
                <b-input-group :prepend="$t('prod_step', { ns: 'production' })">
                    <b-form-input
                        :placeholder="$t('prod_step', { ns: 'production' })"
                        type="number"
                        step="1"
                        v-model.number="localSelected.stapNummer"
                        @change="set_input"
                        :disabled="!editAllowed"
                    ></b-form-input>
                    <b-form-input
                        v-if="false"
                        :placeholder="$t('com_omschrijving', { ns: 'common' })"
                        type="number"
                        step="1"
                        v-model.number="localSelected.stapOmschrijving"
                        @change="set_input"
                        :disabled="!editAllowed"
                    ></b-form-input>
                </b-input-group>
            </b-col>

            <b-col :sm="3" class="mx-0 px-0 my-0 py-0">
                <b-input-group :append="grCelcius">
                    <b-form-input
                        :placeholder="$t('com_temperatuur', { ns: 'common' })"
                        v-model="localSelected.temperatuur"
                        @change="set_input"
                        :disabled="!editAllowed"
                    ></b-form-input>
                </b-input-group>
            </b-col>
            <b-col sm="3" class="mx-0 px-0 my-0 py-0">
                <b-input-group :append="bars">
                    <b-form-input
                        :placeholder="bars"
                        v-model="localSelected.param1"
                        @change="set_input"
                        :disabled="!editAllowed"
                    ></b-form-input>
                </b-input-group>
            </b-col>
        </div>
    </div>
</template>
<script>
import { EquipmentStepInfo } from '../../models/BakInfo';
import { CheeseTijd } from './index';
import DateHelper from '../../models/DateHelper';
import Helper from '../../models/Helper';
import { Feature } from '../../models/Features';
import { loadItem } from '@/models/DataHelper';

export default {
    name: 'EquipmentStepCombo',
    data: function () {
        return {
            bars: 'b',
            grCelcius: window.constants.GRADEN_C,
            lctypeUnits: window.constants.LCPERUNITS,
            errorMessage: '',
            eenheidID: null,
            flexList: [],
            aangeraakt: 1,
            datumtijd: null,
            localDate: null,
            localTijd: null
        };
    },
    model: {
        prop: 'selected',
        event: 'input'
    },
    props: {
        selected: {
            type: EquipmentStepInfo,
            required: true
        },
        editAllowed: {
            type: Boolean,
            default: false
        },
        cheeseProductID: {
            type: Number,
            required: false
        },
        refresh: {
            type: Number,
            required: false
        },
        baseDateTime: {
            type: String
        },
        baseUnit: {
            type: Number,
            default: null
        },
        recept: {
            type: String,
            default: null
        }
    },
    watch: {
        refresh() {
            this.forceRefesh();
        }
    },
    components: {
        CheeseTijd
    },
    computed: {
        useTimeInput() {
            if (this.timeInput) {
                return false;
            }
            return !this.checkFeature('conf_UseDateTimePicker');
        },
        aantKaas() {
            return Helper.stringformat(
                '{0} {1}',
                this.$t('com_number', { ns: 'common' }),
                this.$t('com_kazen', { ns: 'common' }).toLowerCase()
            );
        },
        weightKaas() {
            return Helper.stringformat(
                '{0} {1}',
                this.$t('com_weight', { ns: 'common' }),
                this.$t('com_kazen', { ns: 'common' }).toLowerCase()
            );
        },
        localSelected() {
            return this.selected;
        },
        giveBGclass() {
            return this.localSelected.stepID != undefined &&
                this.localSelected.stepID > 0
                ? 'bg-green'
                : ' bg-blue';
        }
    },
    methods: {
        checkFeature(feature) {
            const key = Feature.enum(feature);
            return this.$root.handleFeature(key);
        },
        set_input: function () {
            this.localSelected.eenheid = this.baseUnit;
            this.localSelected.programma = this.recept;
            this.localSelected.isChanged = true;
            this.$emit('validComponent', true);
            this.$emit('change', true);
            this.$emit('input', this.localSelected);
        },
        set_inputTimePicker(value) {
            const tijd = this.determineDate();
            this.localSelected.tijd = 
                DateHelper.convertedFromTimepicker(tijd, value);
            this.set_input();
        },
        set_inputCheeseTijd(value) {
            if (DateHelper.dateIsValid(value)) {
                this.localSelected.tijd = value;
                this.localSelected.registratieTijd =
                    DateHelper.convertedToDateTimeString(value);
                this.aangeraakt += 1;
                this.set_input();
            }
        },
        setPerstijd() {
            if (this.localDate && this.localTijd) {
                const dateTime = DateHelper.DateFromInput(
                    this.localDate,
                    this.localTijd
                );
                this.localSelected.tijd = dateTime;
                this.localSelected.registratieTijd =
                    DateHelper.convertedToDateTimeString(dateTime);
                this.aangeraakt += 1;
                this.set_input();
            }
        },
        forceRefesh() {
            this.localSelected.registratieTijd =
                DateHelper.convertedToDateTimeString(
                    this.selected.registratieTijd
                );
            this.setTijd(this.localSelected.registratieTijd,this.localSelected.registratieTijd);            
            this.$forceUpdate();
        },
        setTijd(date,time) {
            const localDate = new Date(date);
            this.localDate = DateHelper.DateForInput(
                localDate,
                true,
                false
            );
            const localTime = new Date(time);
            this.localTijd = DateHelper.DateForInput(
                localTime,
                false,
                true
            );
        },
        determineDate() {
            const nu = DateHelper.localLuxonDate();
            const baseDate = this.baseDateTime
                ? DateHelper.MakeDateTime(this.baseDateTime)
                : nu;
            //  als basedate - nu > 24 uur, gebruik basedate
            if (Math.abs(DateHelper.dateDiffinHours(baseDate, nu)) > 24) {
                return this.baseDateTime;
            }
            return new Date();
        }
    },
    mounted() {
        this.datumtijd = this.determineDate();
        this.setTijd(this.datumtijd, new Date(this.localSelected.tijd));
    },
    async created() {
        const lijst = await loadItem(
            'components/loadUnitsComboLijst',
            { aprop: 'test' },
            this.$t
        );
        const o = lijst.find((x) => x.value === this.baseUnit);
        this.bars = o ? o.symbol : null;
    }
};
</script>

<style scoped>
.bg-green {
    background-color: #c1e881 !important;
}
.bg-blue {
    background-color: hwb(203 55% 7%) !important;
}
.fontcolor {
    color: red;
}
</style>
